<table>
  @if (showTitle()) {
    <div>
      <h2 class="m-0">
        {{ translation.unitDetail.cueDevice | transloco }}
      </h2>
    </div>
  }

  @if (unitInfo().magicName) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.magicName | transloco }}:</div>
      </th>
      <td>
        {{ unitInfo().magicName }}
      </td>
    </tr>
  }

  @if (unitInfo().status === UnitInfoStatus.Online) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.status | transloco }}:</div>
      </th>
      <td>
        <span class="dot green"></span>
        {{ translation.unitDetail.online | transloco }}
      </td>
    </tr>
  }

  @if (unitInfo().status === UnitInfoStatus.Offline) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.status | transloco }}:</div>
      </th>
      <td>
        <span class="dot red"></span>
        {{ translation.unitDetail.offline | transloco }}
      </td>
    </tr>
  }

  @if (unitInfo().status === UnitInfoStatus.Unregistred) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.status | transloco }}:</div>
      </th>
      <td>
        <span class="dot grey"></span>
        {{ translation.unitDetail.offline | transloco }}
      </td>
    </tr>
  }

  @if (unitInfo().lastActiveDateTime) {
    <tr>
      <th>
        <div>
          {{ translation.unitDetail.lastActive | transloco }}
        </div>
      </th>
      @if (unitInfo().lastActiveDateTime) {
        <td>
          {{ unitInfo().lastActiveDateTime | dateTimeFormat }}
        </td>
      }
    </tr>
  }
  @if (unitInfo().serialNumber) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.serialNumber | transloco }}:</div>
      </th>
      <td>
        {{ unitInfo().serialNumber }}
      </td>
    </tr>
  }
  @if (unitInfo().firmware) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.firmware | transloco }}:</div>
      </th>
      <td>
        {{ unitInfo().firmware }}
      </td>
    </tr>
  }

  @if (unitInfo().ipAddress) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.ipAddress | transloco }}:</div>
      </th>

      <td>
        <a [href]="unitInfo().ipAddress" target="_blank" rel="noreferrer noopener" class="link">
          {{ unitInfo().ipAddress }}
        </a>
      </td>
    </tr>
  }

  @if (unitInfo().screenshot?.length > 0 || unitInfo().screenshotBlob) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.screenshot | transloco }}:</div>
      </th>
      <td>
        @if (unitInfo().screenshot?.length > 0) {
          <div class="max-w-[300px] mx-left">
            <cue-image [loadWidth]="300" [src]="unitInfo().screenshot" [imgMaxWidth]="'100%'" [imgHeight]="'100%'" />
          </div>
        }

        @if (unitInfo().screenshotBlob) {
          <img [src]="unitInfo().screenshotBlob | imgBlob" />
        }
      </td>
    </tr>
  }

  @if (unitInfo().screenshotLastDownload) {
    <tr>
      <th>
        <div>{{ translation.unitDetail.lastDownloaded | transloco }}:</div>
      </th>

      <td>
        {{ unitInfo().screenshotLastDownload | dateTimeFormat }}
      </td>
    </tr>
  }
</table>
